module.exports = __webpack_public_path__ + "static/avatar-d0ea1628a1827839325880f039d60ac8.jpg";